module.exports = __webpack_public_path__ + "components/media-kit/static/icon-twitter-38cedba8712077fdc1a4d0b8cab5732a.svg";